import { RuleObject } from 'antd/es/form';

import { SearchConsoleAnalyticsFormInputs, SearchConsoleAnalyticsFormValidationSchema } from '@/modules/Domains';
import { Dayjs } from '@seolens/date-manager';

export const searchConsoleAnalyticsFormValidationSchema: SearchConsoleAnalyticsFormValidationSchema = {
  dataState: [],
  startDate: [
    { required: true, message: 'Введіть дату початку' },
    {
      type: 'date',
      message: 'Дата має бути валідною'
    },
  ],
  endDate: [
    { required: true, message: 'Введіть дату завершення' },
    {
      type: 'date',
      message: 'Дата має бути валідною'
    },
    ({ getFieldValue }): RuleObject => ({
      validator(): Promise<void> {
        const valueStart = getFieldValue([SearchConsoleAnalyticsFormInputs.StartDate]) as Dayjs;
        const valueEnd = getFieldValue([SearchConsoleAnalyticsFormInputs.EndDate]) as Dayjs;

        if (valueStart && valueEnd && valueStart > valueEnd) {
          return Promise.reject(new Error('Дата завершення передує даті початку'));
        }
        return Promise.resolve();
      }
    })
  ],
};
